import React from "react"
import { useHistory, useParams } from "react-router-dom"
import { AccountUser, DioboxEvent, Table } from "sharedTypes"
import {
  Modal, ModalContent, ModalOverlay,
} from "@chakra-ui/react"
import SelectedGuest from "../SelectedGuest"

interface SelectedGuestModalProps {
  enhanceEnabled: boolean
  groupsEnabled: boolean
  currency: string
  timezone: string
  tables: Table[]
  teamMembers: AccountUser[]
  event: DioboxEvent
  onClose?: () => void
}

const SelectedGuestModal = ({
  enhanceEnabled,
  groupsEnabled,
  currency,
  timezone,
  tables,
  teamMembers,
  event,
  onClose,
}: SelectedGuestModalProps) => {
  const history = useHistory()
  const { action } = useParams<{ action?: string }>()
  const isEditing = action === "edit" || action === "enrich"

  const handleClose = onClose || (() => history.goBack())

  return (
    <Modal
      isOpen
      onClose={handleClose}
      closeOnOverlayClick={!isEditing}
      closeOnEsc={!isEditing}
      scrollBehavior="outside"
      motionPreset="slideInBottom"
    >
      <ModalOverlay />
      <ModalContent borderRadius="md" maxW="43.75rem" minH="24rem" py={6} px={2}>
        <SelectedGuest
          enhanceEnabled={enhanceEnabled}
          groupsEnabled={groupsEnabled}
          currency={currency}
          timezone={timezone}
          tables={tables}
          teamMembers={teamMembers}
          event={event}
        />
      </ModalContent>
    </Modal>
  )
}

export default SelectedGuestModal
